module.exports = __webpack_public_path__ + "img/kata-sandi.a869407a.svg";